var map = {
	"./form-add.svg": "/PiT",
	"./form-chehui.svg": "cUby",
	"./form-delete.svg": "S5n6",
	"./form-detail.svg": "Idi9",
	"./form-edit.svg": "ymPh",
	"./form-enter.svg": "s8iQ",
	"./form-guidang.svg": "KKs6",
	"./form-jinyong.svg": "sN0/",
	"./form-liulan.svg": "gwLv",
	"./form-look.svg": "G9Db",
	"./form-qiyong.svg": "HxVa",
	"./form-shenhe.svg": "+lrI",
	"./form-shouli.svg": "DtV0",
	"./form-tuishen.svg": "Vu36",
	"./form-weituo.svg": "iBjS",
	"./form-weituoshenji.svg": "2NiH",
	"./form-weituoxieshen.svg": "dLzJ",
	"./form-yichu.svg": "4AAI",
	"./form-zuofei.svg": "iDos"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UZGZ";


//////////////////
// WEBPACK FOOTER
// ./src/icons/form nonrecursive \.svg$
// module id = UZGZ
// module chunks = 13